import { useRecoilState } from "recoil";
import "./Alert.scoped.scss"
import { alertCallbackState, alertMessageState, isOpenAlertState } from "../../atoms/common";
import { getRecoil } from "recoil-nexus";

function Alert() {
  const [isOpenAlert, setIsOpenAlert] = useRecoilState(isOpenAlertState);
  const alertMessage = getRecoil(alertMessageState);
  const alertCallback = getRecoil(alertCallbackState);
  const closeThis = () => {
    alertCallback();
    setIsOpenAlert(false);
  };

  const ok = () => {
    alertCallback();
    setIsOpenAlert(false);
  };

  return (
    <div className="alert-warpper">
      <div className="alert">
        <div className="alert__header">
          <div>알림</div>
          <button onClick={closeThis}>X</button>
        </div>
        <div className="alert__contents">
          <div className="alert__row">
            {alertMessage}
          </div>
          <div className="alert__button">
            <button onClick={ok}>확인</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Alert;